<template>
  <div>
    <v-card>
      <v-tabs
        v-model="activeTab"
        color--text="red"
        grow
      >
        <v-tabs-slider color="#e72b37" />
        <v-tab style="color: #e72b37">
          Benutzerdefinierte Validierungen
        </v-tab>
        <v-tab style="color: #e72b37">
          Kriterienbasierte Validierungen
        </v-tab>
        <v-tab style="color: #e72b37">
          Gesetzlicher Mindestlohn
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <!-- First Tab: Benutzerdefiniert Validierung -->
        <v-tab-item>
          <CustomValidation :can-user-edit="canUserEdit" />
        </v-tab-item>

        <!-- Second Tab: Kriterienbasierte Validierung -->
        <v-tab-item>
          <CriteriaValidation />
        </v-tab-item>

        <!-- Third Tab: Gesetzlicher Mindestlohn -->
        <v-tab-item>
          <v-card-text class="mt-2">
            <MinimumWageValidation :config-id="editionId" />
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
    import MinimumWageValidation from "@/components/minimum.wage/pages/Validation/LegalMinimumWageValidation.vue";
    import CustomValidation from "@/components/minimum.wage/pages/Validation/CustomValidation.vue";
    import CriteriaValidation from "@/components/minimum.wage/pages/Validation/CriteriaValidation.vue";
    import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

    export default {
        components: {
            CustomValidation,
            CriteriaValidation,
            MinimumWageValidation,
        },
        mixins: [MinimumWageMixin],
        data() {
            return {
                activeTab: 0,
            };
        },
        computed: {
            canUserEdit() {
                return (
                    (this.$IsUserInRole("VertragsmanagementVerwaltung") ||
                        (this.$IsUserInRole("VertragsmanagementUniaVertragsverantworlich") &&
                            this.$store.state.mindestLohnKonfiguration.Tenants.find(
                                (x) => x.id == 4,
                            ))) &&
                    this.$IsUserInRole("ZuschlagsrechnerVerwaltung") &&
                    this.$store.state.contractConfiguration.canUserEdit
                );
            },
        },
    };
</script>

<style scoped>
</style>